export default {
  list: {
    name: "article list api",
    version: 6,
    url: "article",
    method: "GET",
  },
  add: {
    name: "add article api",
    version: 6,
    url: "article",
    method: "POST",
  },
  update: {
    name: "update article api",
    version: 6,
    url: "article/%{id}",
    method: "PUT",
  },
  delete: {
    name: "delete article api",
    version: 6,
    url: "article/%{id}",
    method: "DELETE",
  },
  catList: {
    name: "article-category list api",
    version: 6,
    url: "article-category",
    method: "GET",
  },
  catAdd: {
    name: "add article-category api",
    version: 6,
    url: "article-category",
    method: "POST",
  },
  catUpdate: {
    name: "update article-category api",
    version: 6,
    url: "article-category/%{id}",
    method: "PUT",
  },
  catDelete: {
    name: "delete article-category api",
    version: 6,
    url: "article-category/%{id}",
    method: "DELETE",
  },
  tagList: {
    name: "article-tag list api",
    version: 6,
    url: "article-tag",
    method: "GET",
  },
  tagAdd: {
    name: "add article-tag api",
    version: 6,
    url: "article-tag",
    method: "POST",
  },
  tagUpdate: {
    name: "update article-tag api",
    version: 6,
    url: "article-tag/%{id}",
    method: "PUT",
  },
  tagDelete: {
    name: "delete article-tag api",
    version: 6,
    url: "article-tag/%{id}",
    method: "DELETE",
  },
  editorsChoiceList: {
    name: "article-editors-choice list api",
    version: 6,
    url: "article-editors-choice",
    method: "GET",
  },
  editorsChoiceAdd: {
    name: "add article-editors-choice api",
    version: 6,
    url: "article-editors-choice",
    method: "POST",
  },
  editorsChoiceUpdate: {
    name: "update article-editors-choice api",
    version: 6,
    url: "article-editors-choice/%{id}",
    method: "PUT",
  },
  editorsChoiceDelete: {
    name: "delete article-editors-choice api",
    version: 6,
    url: "article-editors-choice/%{id}",
    method: "DELETE",
  },
};
